import {
  OutboundEmailOperation_Read,
  OutboundEmailRecipient_Create,
} from '@treadinc/horizon-api-spec';

import connection from '~services/connectionModule';

import { OutboundEmail } from './models';

export interface OutboundEmailEntry {
  ids: string[];
  message?: string;
  recipients?: OutboundEmailRecipient_Create['email'][];
  subject?: string;
}

export function outboundEmailFields({
  message,
  recipients,
  subject,
}: OutboundEmailEntry) {
  return {
    ...(recipients?.length ? { recipients: recipients.map((email) => ({ email })) } : {}),
    ...(message ? { message } : {}),
    ...(subject ? { subject } : {}),
  };
}

interface SendOutboundEmailsParams {
  errorMessage: string;
  send: () => Promise<{ data: { data: OutboundEmailOperation_Read } }>;
}

export default async function sendOutboundEmails({
  errorMessage,
  send,
}: SendOutboundEmailsParams) {
  try {
    const response = await send();

    return {
      emails: response.data.data.emails.map(OutboundEmail.parse),
      operationId: response.data.data.id,
      recipientCount: response.data.data.count,
    };
  } catch (error) {
    connection.handleRequestError(error, errorMessage);
    throw error;
  }
}
